import { createAction } from '@reduxjs/toolkit';
export const UPDATE_CONFERENCE_PARTICIPANT_LIST = 'UPDATE_CONFERENCE_PARTICIPANT_LIST';
export const updateConferenceParticipantListAction = createAction(UPDATE_CONFERENCE_PARTICIPANT_LIST);